module.exports = "<svg viewBox=\"0 0 117.1 111.6\"><path d=\"M58.6 0v57.4\" class=\"st0\"></path><path d=\"M92.9 105.8L58.6 57.4\" class=\"st0\"></path><path d=\"M58.6 57.4l-34.4 48.4\" class=\"st0\"></path><path d=\"M114.2 40.4l-55.6 17\" class=\"st0\"></path><path d=\"M58.6 57.4l-55.7-17\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/astrics.svg
// module id = 274
// module chunks = 1